import { InputMessageSettings } from './types';

const commonSettings = {
  fontWeight: 1,
  fontFamily: 'secondary',
  fontSize: '0',
  lineHeight: '0',
};

export const inputMessageSettings: InputMessageSettings = {
  componentVariants: {
    type: {
      prop: 'type',
      variants: {
        normal: {
          color: 'gray.dark',
          ...commonSettings,
        },
        error: {
          color: 'danger.main',
          ...commonSettings,
        },
      },
    },
  },
};
